var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfinity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_3423)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.758 18C16.027 18 14.091 16.1 12.3 14.0218C10.494 16.1127 8.56405 18 5.84205 18C2.78605 18 0.300049 15.5327 0.300049 12.5C0.300049 9.46735 2.78605 7 5.84205 7C8.57405 7 10.569 8.93906 12.3 10.9371C14.03 8.94106 16.027 7 18.758 7C21.8143 7 24.3 9.46735 24.3 12.5C24.3 15.5327 21.813 18 18.758 18ZM13.611 12.48C15.232 14.377 16.799 15.9999 18.758 15.9999C20.7113 15.9999 22.3 14.4311 22.3 12.501C22.3 10.5719 20.7113 9.00209 18.758 9.00209C16.77 9.00109 15.204 10.615 13.611 12.48ZM5.84205 9.00109C3.88905 9.00109 2.30005 10.5709 2.30005 12.5C2.30005 14.4301 3.88905 15.9989 5.84205 15.9989C7.81105 15.9989 9.38305 14.3618 10.989 12.478C9.39405 10.615 7.82905 9.00109 5.84205 9.00109Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_3423"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.300049)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfinity);
export default __webpack_public_path__ + "static/media/infinity.5b64f49a683feefdd51b4623ca71fc55.svg";
export { ForwardRef as ReactComponent };